module.exports = __webpack_public_path__ + "static/media/profile.c27bd31c.jpeg";